/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseCheckoutResponse } from '../../models/purchase-checkout-response';

export interface GetProfileCheckoutUniqueLink$Params {

/**
 * ID of profile
 */
  id: number;

/**
 * ID of plan from ChargeBeee
 */
  planId: string;
}

export function getProfileCheckoutUniqueLink(http: HttpClient, rootUrl: string, params: GetProfileCheckoutUniqueLink$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseCheckoutResponse>> {
  const rb = new RequestBuilder(rootUrl, getProfileCheckoutUniqueLink.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('planId', params.planId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseCheckoutResponse>;
    })
  );
}

getProfileCheckoutUniqueLink.PATH = '/rest/profile/{id}/purchase/checkout/{planId}';
